/**
 * Data-api URLs shared by the workflow app. Prefer building from {@link UserContext} `apiConfig.REACT_APEX_BASE_API`.
 */
export function apexAuthLoginUrl(apiBase: string): string {
    const base = apiBase.replace(/\/$/, "");
    return `${base}/action/auth/login`;
}
